import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {RegistrationControllerService} from "../../../../../services/registration-controller/registration-controller.service";
import {RoleRegistrationControllerService} from "../../../../../services/role-controller/role-registration-controller.service";
import {BaseError} from "../../../base-error";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import { hasOwnProp } from "ngx-bootstrap/chronos/utils/type-checks";

@Component({
  selector: "registrations-role",
  templateUrl: "./registrations-role.component.html",
  providers: [RoleRegistrationControllerService, ToastrService],
  styleUrls: ["./registrations-role.component.scss"],
})
export class RegistrationsRoleComponent extends TranslatedBaseError implements OnChanges, OnInit {
  @Input() public registrations = [];
  @Output() public refreshRegistrations = new EventEmitter();

  public serviceId: string;
  public roleId: string;
  public allRegistrations: any[];
  public availableRegistrations: any[];
  public selectedRegistrations: any[] = [];
  public showList: boolean = false;
  public searchInstitutionFilter: any;

  constructor(private roleRegistrationController: RoleRegistrationControllerService,
              private registrationController: RegistrationControllerService,
              public toastr: ToastrService, private route: ActivatedRoute,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.roleId = params.roleId;
      this.ngOnChanges();
    });
    console.log("--- role registrations", this.registrations);
  }

  public ngOnChanges() {
    this.getSystemRegistrations();
  }

  public removeRoleRegistration(isConfirmed, registrationId) {
    if (isConfirmed) {
      this.roleRegistrationController.deleteRoleRegistration(registrationId).subscribe(
        (data) => this.throwRefreshRegistrations(),
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public throwRefreshRegistrations() {
    this.refreshRegistrations.emit();
  }

  public getSystemRegistrations() {
    if (this.serviceId) {
      this.registrationController.getRegistrationsList(this.serviceId).subscribe(
        (data) => {
          this.allRegistrations = data;
          console.log(data);
          this.pushValuesToDropdown();
        },
        (error) => this.showErrorMessageWithTitle("Unable to get registrations list", error),
      );
    }
  }

  public pushValuesToDropdown() {
    const that = this;
    this.availableRegistrations = [];
    this.selectedRegistrations = [];
    this.allRegistrations.forEach((registration) => {
      let isSelected = false;
      if (that.registrations.some((r) => r.registrationId === registration.id)) {
        that.registrations.forEach((selectedRegistration) => {
          if (!selectedRegistration.hasOwnProperty('finalResultIssued')) {
            selectedRegistration.finalResultIssued = false;
          }
          if (registration.id === selectedRegistration.registrationId) {
            selectedRegistration.text = registration.name;
            selectedRegistration.hasResult = registration.hasResult;
            that.selectedRegistrations.push(selectedRegistration);
            isSelected = true;
          }
        });
      } else {
        that.availableRegistrations.push({id: registration.id, text: registration.name, finalResultIssued: false, hasResult: registration.hasResult});
      }
    });
    console.log("--- that.selectedRegistrations", that.selectedRegistrations, this.availableRegistrations);
  }

  public selected(values: any): void {
    const registrationIds = values.map((registration) => {
      return registration.id;
    });
    const saveRegistraitons = registrationIds.concat(this.selectedRegistrations.map((registration) => {
      return registration.registrationId;
    }));
    this.roleRegistrationController.createRoleRegistrations(this.roleId, saveRegistraitons).subscribe(
      (data) => this.throwRefreshRegistrations(),
      (error) => this.showErrorMessageWithTitle("Unable to add role registration", error),
    );
  }

  public selectAllRegistrations(): void {
    const registrationIds = this.allRegistrations.map((registration) => {
      return registration.id;
    });

    this.roleRegistrationController.createRoleRegistrations(this.roleId, registrationIds).subscribe(
      (data) => this.throwRefreshRegistrations(),
      (error) => this.showErrorMessageWithTitle("Unable to add role registration", error),
    );
  }

  public saveRegistration(registration) {
    this.roleRegistrationController.saveRoleRegistration(registration.registrationId, registration).subscribe(
      (data) => this.throwRefreshRegistrations(),
      (error) => this.showErrorMessageWithTitle("Unable to save role registration", error),
    );
  }

  public removed(value: any) {
    this.registrations.forEach((registration) => {
      if (registration.registrationId === value.registrationId) {
        return this.removeRoleRegistration(true, registration.id);
      }
    });
  }

  public searchInstitutionChanged(value: any): void {
    this.searchInstitutionFilter = { name: value };
}

}
